import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { cloneDeep } from 'lodash-es';

import { API_URL } from '@constants';
import { Comment, Discussion } from '@models';
import { CommentService, ModalService } from '@services';

@Service()
export class DiscussionService {
  modalService = inject(ModalService);
  commentService = inject(CommentService);
  http = inject(HttpClient);

  updateDiscussion = (rid: number, data: Partial<Discussion>) =>
    this.http.put<Discussion>(`${API_URL}/discussions/${rid}`, data);

  getDiscussion = (rid: number) =>
    this.http.get<Discussion>(`${API_URL}/discussions/${rid}`);

  addComment = (
    rid: number,
    data: { text: string; replyTo?: number | string }
  ) => this.http.post<Comment>(`${API_URL}/discussions/${rid}/comments`, data);

  getComments = (
    rid: number,
    params?: HttpParams | Record<string, string | number>
  ) =>
    this.http.get<Comment[]>(`${API_URL}/discussions/${rid}/comments`, {
      params,
    });

  deleteComment = (commentId: number) =>
    this.commentService.deleteComment(commentId);

  openDiscussion = async (rid: number) => {
    const { DiscussionComponent } =
      await import('../../modules/discussion/components/discussion.component');

    return this.modalService.open(
      DiscussionComponent,
      {
        resourceRid: rid,
      },
      {
        windowClass: 'discussion-modal',
      }
    );
  };

  editDiscussion = async (resource: Discussion) => {
    const { EditDiscussionModalComponent } =
      await import('../../modules/discussion/components/edit-discussion-modal.component');

    return this.modalService.open(
      EditDiscussionModalComponent,
      {
        resource: cloneDeep(resource),
      },
      {
        windowClass: 'lg-modal',
      }
    );
  };
}
